import { render, staticRenderFns } from "./ModalAddProductCurrentStock.vue?vue&type=template&id=b1f55044&scoped=true"
import script from "./ModalAddProductCurrentStock.vue?vue&type=script&lang=js"
export * from "./ModalAddProductCurrentStock.vue?vue&type=script&lang=js"
import style0 from "./ModalAddProductCurrentStock.vue?vue&type=style&index=0&id=b1f55044&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f55044",
  null
  
)

export default component.exports